// extracted by mini-css-extract-plugin
export default {"container":"ProductsStateBox_container__farbc","productsCount":"ProductsStateBox_productsCount__4YD-2","percentage":"ProductsStateBox_percentage__ULW5m"};